export enum PaymentColumns {
	id = "Id",
	org = "Org",
	bank = "Bank",
	type = "Type",
	accountId = "Account",
	customer = "Customer",
	amount = "Amount",
	status = "Status",
	createdAt = "Created At",
	actions = "Actions",
	reason = "Reason",
	expectedCompletionDate = "Expected Completion Date",
}

export type AllowedPaymentColumns =
	| PaymentColumns.id
	| PaymentColumns.org
	| PaymentColumns.bank
	| PaymentColumns.type
	| PaymentColumns.accountId
	| PaymentColumns.customer
	| PaymentColumns.amount
	| PaymentColumns.status
	| PaymentColumns.createdAt
	| PaymentColumns.actions
	| PaymentColumns.reason
	| PaymentColumns.expectedCompletionDate
